import React from "react";
import VariantOptionRadio from "@/components/ProductPackages/VariantOptionRadio";
import { useCartData } from "@/zustand/cartStore.js";
import { useProductData } from "@/zustand/productStore.js";
import SizeChart from "@/components/SizeChart";

const VariantsPickerSeparate = () => {
  const { variants, setVariants } = useCartData();
  const productData = useProductData();
  const variantsBase = window.post_template?.checkout_v4_products;
  const sizeChartLabel = variantsBase?.tr_checkout_v4_sizeChartLabel;
  const sizeChartLink = variantsBase?.checkout_v4_sizeChartLink;

  const handleColorChange = (sku, label) => {
    const updatedVariants = variants.map((item) => {
      return {
        ...item,
        color: sku,
        colorLabel: label,
      };
    });
    setVariants({ variants: updatedVariants });
  };

  const handleSizeChange = (sku, label) => {
    const updatedVariants = variants.map((item) => {
      return {
        ...item,
        size: sku,
        sizeLabel: label,
      };
    });

    setVariants({ variants: updatedVariants });
  };

  const heading = window?.post_template.checkout_v4_products?.tr_checkout_v4_bundleVariantHeading;

  return (
    <section className="variants-container--radio">
      <div className="variants-container--separate-picker">
        {heading && (
          <h3
            data-testid="products-label"
            className={`productPackages__heading ${window.enhancedContrast && "enhancedContrast"}`}
          >
            {heading}
          </h3>
        )}
        <SizeChart sizeChartLink={sizeChartLink} sizeChartLabel={sizeChartLabel} />
      </div>
      <div className="variants-container__wrapper">
        {productData?.product_size_variants?.length > 0 && productData?.enable_size_variants && (
          <>
            <div className="variant-container--radio">
              {productData?.product_size_variants?.map((variant, index) => (
                <VariantOptionRadio
                  key={index}
                  label={variant.tr_label}
                  sku={variant.value}
                  type="size"
                  size={productData?.product_size_variants?.length}
                  handleClick={(sku, label) => {
                    handleSizeChange(sku, label);
                  }}
                />
              ))}
            </div>
          </>
        )}
        {Array.isArray(productData?.product_color_variants) &&
          productData.product_color_variants.length > 0 &&
          productData?.enable_color_variants && (
            <>
              <div className="variant-container--radio">
                {productData.product_color_variants.map((variant, index) => (
                  <VariantOptionRadio
                    key={index}
                    label={variant?.tr_label}
                    sku={variant.value}
                    type="color"
                    color={variant?.color_hex}
                    size={productData.product_color_variants.length}
                    handleClick={(sku, label) => {
                      handleColorChange(sku, label);
                    }}
                  />
                ))}
              </div>
            </>
          )}
      </div>
    </section>
  );
};

export default VariantsPickerSeparate;
